import React from 'react';
import _get from 'lodash/get';
import classNames from 'classnames';
import {
  components as DefaultSelectComponents,
  OptionProps,
} from 'react-select';
import { LanguageEnum } from 'graphql-common';
import { getLangFlagCode } from '@lib/utils/lang';
import styles from '../Select.module.scss';

function LangOption({
  children,
  ...restProps
}: OptionProps): React.ReactElement {
  const { isSelected, isMulti } = restProps;
  const value = _get(restProps, 'value', '') as LanguageEnum;
  return (
    // @ts-ignore
    <DefaultSelectComponents.Option
      {...restProps}
      className={classNames(styles.countryOption, {
        active: isSelected,
        [styles.optionWithCheckbox]: isMulti,
      })}
    >
      <span
        className={classNames(styles.flag, styles[getLangFlagCode(value)])}
      />
      {children}
    </DefaultSelectComponents.Option>
  );
}

export default LangOption;
